(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/components/freja/freja-start.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/components/freja/freja-start.js');

'use strict';

const {
  Button,
  ReactBank: Bank
} = svs.ui;
const {
  Qr,
  SelectorButtons
} = svs.iam_login.components.shared;
const {
  isPnp
} = svs.iam_login.data;
const login = svs.iam_login.utils.Login;
const {
  useAtomValue
} = jotai;
const {
  activeMethodAtom
} = svs.iam_login.atoms;
const {
  abortUrl
} = svs.iam_login.data;
const FrejaStart = _ref => {
  let {
    showQR,
    isNewCustomer
  } = _ref;
  const activeMethod = useAtomValue(activeMethodAtom);
  const isFrejaDesktop = activeMethod.isFreja && !showQR;
  return React.createElement("div", {
    className: isPnp ? 'momang' : ''
  }, React.createElement(SelectorButtons, null), showQR && React.createElement(Qr, {
    isNewCustomer: isNewCustomer,
    isPnp: isPnp
  }), React.createElement("div", {
    className: "login-buttons-container"
  }, isFrejaDesktop && React.createElement(Button, {
    block: true,
    className: "btn-green margin-top-1 margin-bottom-1",
    iconPosition: "left",
    inverted: !isPnp,
    onClick: () => {
      login.start(isNewCustomer);
    },
    size: 300
  }, React.createElement(Bank, {
    height: 24,
    name: activeMethod.icon
  }), isNewCustomer ? 'Bli kund' : 'Logga in'), React.createElement(Button, {
    block: true,
    className: "",
    onClick: () => {
      window.location.href = abortUrl || '/';
    },
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.iam_login.components.freja.FrejaStart = FrejaStart;

 })(window);